export default "__VITE_ASSET__wyssSGRH__"